import { Feature } from '@tencent/workbench';
import BaseMobileContextMenuFeature from '@framework/workbench/common/feature/base-mobile-context-feature';
import { config } from './config';

@Feature()
export class AllSelectFeature extends BaseMobileContextMenuFeature {
    id = config.name;

    public allSelect() {
        this.editorInstance?.setSelectionAll?.();
    }
}
